import { API } from "@swivl-mono/api-helper";
import { APIScope, EmbedInterface, GroupInterface, LocationInterface } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";

interface StoreInterface {
  embeds?: { [embedId: number]: EmbedInterface };
}

const BlankState: StoreInterface = {
  embeds: undefined
};

export default class EmbedsModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = EmbedsModel.useState.setState;
  static get state() {
    return EmbedsModel.useState.getState();
  }
  static reset() {
    EmbedsModel.setState({ ...BlankState });
  }

  static async load(force: boolean) {
    if (!force && EmbedsModel.state.embeds) return;
    API.Embeds.getEmbeds(Member.orgId!).then((embeds) => {
      EmbedsModel.setState({
        embeds: embeds
          .sort((a, b) => a.name.localeCompare(b.name))
          .reduce(
            (acc, embed) => {
              acc[embed.id] = embed;
              return acc;
            },
            {} as { [embedId: number]: EmbedInterface }
          )
      });
    });
  }
  static updateEmbed(embed: EmbedInterface, shouldSave: boolean = true) {
    let embeds = { ...EmbedsModel.state.embeds };
    if (!embeds) return;
    embeds[embed.id] = embed;
    EmbedsModel.setState({ embeds: embeds });
    if (shouldSave) {
      API.Embeds.updateEmbed(Member.orgId!, embed).then((updated) => {});
    }
  }
  static create() {
    return API.Embeds.createEmbed(Member.orgId!, { name: "New Embed" }).then((embed) => {
      let embeds = { ...EmbedsModel.state.embeds };
      if (!embeds) return;
      embeds[embed.id] = embed;
      EmbedsModel.setState({ embeds: embeds });
    });
  }

  static deleteEmbed(embedId: number) {
    return API.Embeds.deleteEmbed(Member.orgId!, embedId).then(() => {
      let embeds = { ...EmbedsModel.state.embeds };
      if (!embeds) return;
      delete embeds[embedId];
      EmbedsModel.setState({ embeds: embeds });
    });
  }
}
